import type { MarketData, OverlaySpec, PanelSpec } from "../types";

export type IndicatorSettings = Record<string, number>;

export interface IndicatorResult {
  overlays?: OverlaySpec[];
  panel?: PanelSpec;
}

export interface Indicator {
  id: string;
  name: string;
  group: "overlay" | "panel" | "tick";
  defaults: IndicatorSettings;
  calculate(data: MarketData, settings: IndicatorSettings, color: string): IndicatorResult;
}

// An indicator placed on a chart: definition + settings instance.
export interface ActiveIndicator {
  key: string;
  id: string;
  label: string;
  color: string;
  settings?: IndicatorSettings;
}

const registry = new Map<string, Indicator>();

export function registerIndicator(ind: Indicator) { registry.set(ind.id, ind); }
export function getIndicator(id: string): Indicator | undefined { return registry.get(id); }
export function listIndicators(): Indicator[] { return Array.from(registry.values()); }
